import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type Messages as SchemaMessages } from '../schemas/Messages';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Messages
 */
export const GetMessagesContentType = '' as const;
export type GetMessagesRequest = void;
export type GetMessagesResponses = LinkCommonErrorResponses & {
    /**
     * @description List of messages with read status
     */
    '200': {
        'application/json': SchemaMessages;
    };
};
export type GetMessagesResponseSuccess = GetMessagesResponses['200']['application/json'];
export type GetMessagesSearchParams = {
    per_page?: number;
    page?: number;
};
export type GetMessagesPathParameters = undefined;
export const GetMessagesUrl = '/messages' as const;
export const GetMessagesMethod = 'GET' as const;
export const getGetMessagesUrl = (_params?: GetMessagesPathParameters) => GetMessagesUrl;
